import { render, staticRenderFns } from "./addDrug.vue?vue&type=template&id=4d40e1a7&scoped=true&"
import script from "./addDrug.vue?vue&type=script&lang=js&"
export * from "./addDrug.vue?vue&type=script&lang=js&"
import style0 from "./addDrug.vue?vue&type=style&index=0&id=4d40e1a7&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d40e1a7",
  null
  
)

export default component.exports